import { MenuItem2 } from "@blueprintjs/popover2";
import { MultiSelect2, MultiSelect2Props } from "@blueprintjs/select";
import classNames from "classnames";
import React from "react";

import { Item, ItemRendererComponentProps, Tag } from "./components";
import { UseMultiSelect } from "./hooks";
import styles from "./multi-select.module.scss";
import { MultiSelectItem } from "./types";
import { filterItem } from "./utils";

export interface MultiSelectProps<TItem extends MultiSelectItem>
  extends UseMultiSelect<TItem>,
    Omit<
      MultiSelect2Props<TItem>,
      "items" | "selectedItems" | "onItemSelect" | "onRemove" | "onClear" | "itemRenderer" | "tagRenderer"
    >,
    Pick<ItemRendererComponentProps<TItem>, "itemRenderer"> {
  tagRenderer?: Partial<Pick<MultiSelect2Props<TItem>, "tagRenderer">>["tagRenderer"];
  placeholder?: string;
  className?: string;
}

export const MultiSelect = <TItem extends MultiSelectItem>({
  items,
  selectedItems,
  isSingleSelect,
  onItemSelect,
  onRemove,
  onClear,
  isItemSelected,
  tagRenderer,
  itemRenderer,
  placeholder = "Search...",
  className = "",
  ...props
}: MultiSelectProps<TItem>) => {
  return (
    <MultiSelect2<TItem>
      {...props}
      className={classNames(styles.multiSelect, className)}
      menuProps={{ className: styles.dropdownMenu }}
      resetOnSelect
      items={items}
      itemRenderer={(item, itemProps) => (
        <Item
          key={item.id}
          item={item}
          props={{ ...itemProps, selected: isItemSelected(item) }}
          itemRenderer={itemRenderer}
        />
      )}
      noResults={<MenuItem2 disabled={true} text="No results" roleStructure="listoption" />}
      itemPredicate={filterItem}
      onItemSelect={onItemSelect}
      onRemove={onRemove}
      selectedItems={selectedItems}
      popoverProps={{ minimal: true }}
      tagRenderer={tagRenderer || ((item) => Tag({ item, selectedItems }))}
      onClear={isSingleSelect ? undefined : onClear}
      placeholder={placeholder}
    />
  );
};
